'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _keyControlContainer = require('./keyControl/keyControlContainer');
var _keyControlContainer2 = _interopRequireDefault(_keyControlContainer);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var JPlaylist = function JPlaylist(_ref) {
  var states = _ref.states,
    keyBindings = _ref.keyBindings,
    children = _ref.children,
    id = _ref.id;
  return _react2.default.createElement(_keyControlContainer2.default, {
    keyBindings: keyBindings
  }, _react2.default.cloneElement(_react2.default.Children.only(children), {
    states: states,
    id: id
  }));
}; /* eslint-disable react/forbid-prop-types */

JPlaylist.defaultProps = {
  keyBindings: null
};
JPlaylist.propTypes = {
  id: _propTypes2.default.string.isRequired,
  states: _propTypes2.default.object.isRequired,
  keyBindings: _propTypes2.default.object,
  children: _propTypes2.default.element.isRequired
};
exports.default = JPlaylist;